module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/hummer-2-4b91788051bb12c9779807230c40119a.svg";